import React, { useState } from "react";
import { Formik, useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { requestPassword } from "../_redux/authCrud";
import { forgotPasswordss } from "../_redux/authCrud"

const initialValues = {
  phoneNumber: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const [isRequested, setIsRequested] = useState(false);

  const ForgotPasswordSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      // .phoneNumber("Invalid Phone Number")
      .min(10, "Minimum 10 symbols")
      .max(10, "Maximum 10 symbols")
      // .required(
      //   "Valid Phone Number Required"
      // ),
      .required("Not a Valid Identifier")
  });


  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      forgotPasswordss(values.phoneNumber)
        .then(({ data }) => {
          setIsRequested(true)
          userOnBoardingProcess(data.message);
        })
        .catch((err) => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(err.response.data.message
            /*intl.formatMessage(
              { id: "AUTH.VALIDATION.NOT_FOUND" },
              { name: values.phoneNumber }
            )*/
          );
        });
    },
  });


  const userOnBoardingProcess = (status) => {
    props.history.push(`/auth/reset-password`, {status});
  };

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 style={{ color: 'white' }} className="font-size-h1">Forgotten Password ?</h3>
            <div className="text-muted font-weight-bold">
              Enter Your Registered Phone Number
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate_animated animate_backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Phone Number"
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "phoneNumber"
                )}`}
                name="phoneNumber"
                {...formik.getFieldProps("phoneNumber")}
              />
              {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.phoneNumber}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                Submit
              </button>
              <Link to="/auth/login">
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Cancel
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));